import env from '@/config/env'
import request from '@/router/axios'

/**
 * 获取临时密码
 * @returns
 */
export const getTempPwd = (data) => {
  return request({
    url: `/custom-auth/universal-cipher?userId=${data.userId}`,
    method: 'GET'
  })
}

/**
 * 获取账号分页数据
 * @param sysUserPage
 */
export const getAccountPage = (sysUserPage) => {
  return request({
    url: env.ferryUrl + '/user/getPage',
    method: 'POST',
    data: sysUserPage
  })
}

/**
 * 获取供应商树形结构
 */
export const getMerchantTree = () => {
  return request({
    url: env.ferryUrl + '/user/getTreeMerchant',
    method: 'POST'
  })
}

/**
 * 获取当前用户所在的供应商列表
 */
export const getMerchantForCurrentUser = () => {
  return request({
    url: env.ferryUrl + '/merchant/getMerchantList',
    method: 'GET'
  })
}

/**
 * 获取当前用户的关联站点
 */
export const getStationForCurrentUser = (userId) => {
  return request({
    url: env.ferryUrl + '/merchant/getMyMerchantFerryStation?sysUserId=' + userId,
    method: 'GET'
  })
}

/**
 *  @description 通过供应商id获取关联站点
 * @param merchantId
 */
export const selectStationByMerchantId = (merchantId) => {
  return request({
    url: env.ferryUrl + `/merchant/getMerchantFerryStationById?id=${merchantId}`,
    method: 'GET'
  })
}

/**
 * 保存当前用户的站点信息
 * @param data
 */
export const saveStationForCurrentUser = (data, param) => {
  console.log('param', param)
  return request({
    url: env.ferryUrl + '/merchant/setBindStations?sysUserId=' + param.userId,
    method: 'POST',
    data
  })
}

/**
 *
 * @param merchantId
 */
export const selectRoleListByMerchantId = (merchantId) => {
  return request({
    url: env.ferryUrl + `/user/getList/${merchantId}`,
    method: 'GET'
  })
}

/**
 * 保存用户
 * @param sysUserDTO
 */
export const saveAccount = (sysUserDTO) => {
  return request({
    url: env.ferryUrl + '/user',
    method: 'POST',
    data: sysUserDTO
  })
}

/**
 * 编辑用户
 */
export const updateAccount = (sysUserDTO) => {
  return request({
    url: env.ferryUrl + '/user',
    method: 'PUT',
    data: sysUserDTO
  })
}

/**
 * 启用和禁用账号
 */
export const handleEnable = (sysUserDTO) => {
  return request({
    url: env.ferryUrl + '/user/handleEnable',
    method: 'POST',
    data: sysUserDTO
  })
}

/**
 * 删除账号
 */
export const deleteAccount = (id) => {
  return request({
    url: env.ferryUrl + `/user/${id}`,
    method: 'DELETE'
  })
}

/**
 * 重置密码
 */
export const setPassword = (resetPassword) => {
  return request({
    url: env.ferryUrl + '/user/resetPassword',
    method: 'POST',
    data: resetPassword
  })
}

// 重置密码——管理员
export const resetPasswordAdmin = (params) => {
  return request({
    url: env.ferryUrl + '/user/resetPassword/admin',
    method: 'POST',
    params
  })
}
